import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-255a0c85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-footer" }, null, -1))

import { ref, computed, watch } from 'vue'
import { CODE_ENUM, SUFFIX, PAGE_SIZES } from '@/common'
import { queryFirmwarebatchUpgrade } from '@/api'
import { isEmpty } from 'lodash'
import { ElMessage } from 'element-plus'
import OperationButtonList from '@/components/operation-button-list'
import moment from 'moment'
import BatchUpdateNoList from './batch-update-no-list.vue'
import { formatFormTime } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'batch-update-no',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const formRef = ref()

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      fetchList()
    }
  }
)

const getButtonList = () => {
  return [
    {
      type: 'detail',
      text: '详情',
      onClick: (row: any) => {
        toDeviceUpdateNoConf(row)
      },
    },
  ]
}

const formInline = ref({
  upgradeNo: '',
  createTime: [],
})
const loading = ref(false)

const tableData = ref([])
const tableLoading = ref(false)

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const getMoTime = (keepAliveData: any) => {
  return {
    ...formatFormTime(keepAliveData.createTime, ['startTime', 'endTime']),
  }
}

const search = ()=>{
  pageParams.value.curPage = 1
  fetchList()
}

const reset = ()=>{
  formRef.value?.resetFields?.()
  pageParams.value.curPage = 1
  fetchList()
}

const fetchList = async () => {
  tableLoading.value = true
  const { upgradeNo, createTime } = formInline.value
  const res: any = await queryFirmwarebatchUpgrade({
    ...pageParams.value,
    ...getMoTime({ createTime }),
    upgradeNo,
  })
  tableLoading.value = false

  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const handleClose = () => {
  $emit('update:visible', false)
}

const col = [
  {
    label: '升级编号',
    prop: 'upgradeNo',
  },
  {
    label: '升级数量',
    prop: 'upgradeNum',
  },
  {
    label: '升级时间',
    prop: 'createDate',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
]

const deviceUpdateNoConf = ref({
  visible: false,
  data: {},
})
const toDeviceUpdateNoConf = (data: any) => {
  deviceUpdateNoConf.value = {
    visible: true,
    data,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "model-value": props.visible,
      title: "升级历史",
      width: "1100",
      "before-close": handleClose
    }, {
      footer: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          inline: true,
          model: formInline.value,
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "升级编号",
              prop: "upgradeNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formInline.value.upgradeNo,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.upgradeNo) = $event)),
                  style: {"width":"280px"},
                  placeholder: "请输入版本",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "时间",
              prop: "createTime",
              class: "ws_time_range create-time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: formInline.value.createTime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.createTime) = $event)),
                  "unlink-panels": "",
                  type: "datetimerange",
                  "range-separator": "-",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  editable: false,
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查询 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  plain: "",
                  onClick: reset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 重置 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_table, {
            data: tableData.value,
            class: "ws_common_table"
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, { description: "暂无数据" })
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
                return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
            ...item,
          }), null, 16)
              }), 64)),
              _createVNode(_component_el_table_column, {
                width: 160,
                label: "操作"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(OperationButtonList), {
                    scope: scope.row,
                    buttonList: getButtonList()
                  }, null, 8, ["scope", "buttonList"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode(_component_el_pagination, {
            class: "ws_mt50 ws_mb36",
            "current-page": pageParams.value.curPage,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
            "page-size": pageParams.value.pageSize,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
            "page-sizes": _unref(PAGE_SIZES),
            layout: "->, total, sizes, prev, pager, next, jumper ",
            total: total.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
        ])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(BatchUpdateNoList, {
      visible: deviceUpdateNoConf.value.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((deviceUpdateNoConf.value.visible) = $event)),
      data: deviceUpdateNoConf.value.data
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})